import React, { Component } from "react";
import ReactTable from "react-table";
import Pagination from "./Pagination";
import "react-table/react-table.css";
import "../../static/css/react-table-override.css";
import loader from "../../static/imgs/loader.svg";

class DashboardDataTable extends Component {
  render() {
    return this.props["data"] ? (
      <div className={window.safari !== undefined ? "safari-brw" : "other-brw"}>
        <div className="table-wrpr width-change">
          <ReactTable
            data={this.props.data}
            columns={this.props.columns}
            defaultSorted={[
              {
                id: this.props.defaultSorted,
                desc: this.props.desc
              }
            ]}
            defaultPageSize={50}
            minRows={1}
            className="-striped"
            PaginationComponent={Pagination}
            noDataText="No Data Available"
          />
        </div>
      </div>
    ) : (
      <div className="loader-wrpr text-center width-change">
        <img src={loader} alt="Loading..."></img>
      </div>
    );
  }
}
export default DashboardDataTable;
